import { epoqForeignInit } from "@ocm/services/services.epoq";

function init() {
	if (
		!document.getElementById("js-epoqSPA") &&
		!document.body.classList.contains("page-multiStepCheckoutSummaryPage")
	) {
		epoqForeignInit("Global");
	}
}

export { init };
